
<template>
    <div>

        <TotalAndAssignedCards :dataLoaded="dataLoaded"
                               :totalItems="totalItems"
                               :totalAssignedToYourTeams="totalAssignedToYourTeams"
                               :totalAssignedToYou="totalAssignedToYou"
                               :sparklines="sparklines"
                               v-model:filterByMyTeams="filterByMyTeams"
                               v-model:filterByMe="filterByMe"
                               @filterChange="handleFilterChange" />

        <v-row>
            <v-col cols="12" md="8">
                <StackedHorizontalBarChart :title="$t('drawingBreakdown')"
                                           :exportFilename="$t('drawingBreakdown') + '.png'"
                                           v-bind="drawingChart"
                                           :filterContext="filterContext"
                                           :chartFontColor="chartFontColor"
                                           :dataLoaded="dataLoaded"
                                           skipEmptyLevels />
            </v-col>
            <v-col cols="12" md="4">
                <StackedHorizontalBarChart :title="$t('issueBreakdown')"
                                           :exportFilename="$t('issueBreakdown') + '.png'"
                                           v-bind="categoryChart"
                                           :filterContext="filterContext"
                                           :chartFontColor="chartFontColor"
                                           :dataLoaded="dataLoaded"
                                           skipEmptyLevels />
            </v-col>
        </v-row>

        <!-- Gantt Chart: package BaseGanttChart + useIssueDueByGanttChart (IA_ABSORPTION_PLAN 13b) -->
        <v-row>
            <v-col cols="12" md="12">
                <BaseGanttChart :title="$t('dueByAnalysis')"
                                v-bind="ganttChart"
                                :statusOptions="ganttStatusOptions"
                                v-model:selectedStatuses="ganttSelectedStatuses"
                                :filterContext="filterContext"
                                :dataLoaded="ganttReady"
                                @taskSelected="handleGanttTaskSelected" />
            </v-col>
        </v-row>

        <!-- Issues Grid -->
        <v-row>
            <v-col cols="12">
                <IssuesGrid v-bind="issuesGrid" />
            </v-col>
        </v-row>
    </div>
</template>

<script src="./model.js"></script>
<style src="./style.css" scoped></style>
